import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';
import PlayerLink from 'components/PlayerLink';
import { Table, Th, Td } from 'components/Table';

export default class AwardsPage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { awards, seasons, winners, teamAwards } = this.props;
        return (
            <Main>
                <MainHeader />
                <Body id="awards-page">
                    <CurrentWinners awards={awards} season={seasons[0]} winners={winners[seasons[0]]} />
                    <TeamAwards teamAwards={teamAwards} />
                    <Panel border>
                        <PanelTop title="Award History" />
                        <div className="awards-main-table">
                            <AwardsTable awards={awards} seasons={seasons} winners={winners} />
                        </div>
                    </Panel>
                </Body>
            </Main>
        );
    }
}

const CurrentWinners = ({ awards, season, winners }) => (
    <Panel className="awards-winners">
        <PanelTop title={`Award Winners ${season}`} />
        {awards.map(award => <CurrentWinner key={award.id} award={award} winner={winners[award.id]} />)}
    </Panel>
);

const CurrentWinner = ({ award, winner }) =>
    winner ? (
        <div className="cc-card">
            <div className="awards-current-desc">{award.desc}</div>
            <AwardWinner winner={winner} />
        </div>
    ) : null;

const TeamAwards = ({ teamAwards }) => (
    <Panel className="awards-teams">
        <PanelTop title="Team/Club Achievements" />
        {teamAwards.map(({ tid, lname, season, description }) => (
            <div key={`${tid}${season}`} className="cc-card">
                <div>{`${season} - ${description}`}</div>
                <div>{tid ? lname : ''}</div>
            </div>
        ))}
    </Panel>
);

const AwardsTable = ({ awards, seasons, winners }) => (
    <Table striped hover>
        <thead>
            <tr>
                <Th left>Season</Th>
                {awards.map(award => (
                    <Th left key={award.id}>
                        {award.name}
                    </Th>
                ))}
            </tr>
        </thead>
        <tbody>{seasons.map(season => <AwardsRow key={season} awards={awards} season={season} winners={winners[season]} />)}</tbody>
    </Table>
);

const AwardsRow = ({ awards, season, winners }) => (
    <tr>
        <Td>{season}</Td>
        {awards.map(award => (
            <Td key={award.id} left>
                <AwardWinner winner={winners[award.id]} />
            </Td>
        ))}
    </tr>
);

const AwardWinner = ({ winner }) => {
    if (winner) {
        if (winner.pid) {
            return <PlayerLink pid={winner.pid} fname={winner.fname} lname={winner.lname} />;
        }
        if (winner.name) {
            return <span>{winner.name}</span>;
        }
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/views/awards/AwardsPage.jsx